<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Visita domiciliar - Inconsistências"
    >
        <template v-if="data">
            
            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />
            
            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Atendimentos"
                type="fieldset"
            >                         

                
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="atendimentosComInconsistencia"
                    class="p-0"
                >
                     
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <span>{{ item.paciente.campos.posicao }} - </span>
                                <strong>Paciente:</strong> {{ item.paciente.campos.nomeCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.paciente.campos.cnsCidadao }}
                            </rkm-col>

                                <rkm-col>
                                    <strong>Data de nascimento:</strong> {{ item.paciente.campos.dtNascimento }}
                                </rkm-col>
                            </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-area
                                title="Identificação do paciente"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="6">
                                        <Item
                                            label="Nome"
                                            :value="item.paciente.campos.nomeCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="CNS"
                                            :value="item.paciente.campos.cnsCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="CPF"
                                            :value="item.paciente.campos.cpfCidadao"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="2">
                                        <Item
                                            label="Prontuário"
                                            :value="item.paciente.campos.numProntuario"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="2">
                                        <Item
                                            label="Data de nascimento"
                                            :value="item.paciente.campos.dtNascimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="2">
                                        <Item
                                            label="Sexo"
                                            :value="item.paciente.campos.sexo"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Microárea"
                                            :value="item.paciente.campos.microArea"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Fora de área"
                                            :value="item.paciente.campos.stForaArea"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.paciente.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Atendimento"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Turno"
                                            :value="item.atendimento.campos.turno"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Tipo de imóvel"
                                            :value="item.atendimento.campos.tipoDeImovel"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Latitude"
                                            :value="item.atendimento.campos.latitude"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Longitude"
                                            :value="item.atendimento.campos.longitude"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            label="Visita compartilhada com outro profissional"
                                            :value="item.atendimento.campos.statusVisitaCompartilhadaOutroProfissional"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.atendimento.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Motivo da visita"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.motivosVisita.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'Motivo' }]"
                                />

                                <Inconsistencia :inconsistencias="item.motivosVisita.inconsistencias" />
                            </rkm-area>

                            <rkm-row>
                                <rkm-col cols="6">
                                    <rkm-area
                                        title="Avaliação antropométrica"
                                        type="fieldset"
                                    >
                                        <rkm-row>
                                            <rkm-col cols="6">
                                                <Item
                                                    label="Peso (kg)"
                                                    :value="item.avaliacaoAntropometrica.campos.pesoAcompanhamentoNutricional"
                                                />
                                            </rkm-col>

                                            <rkm-col cols="6">
                                                <Item
                                                    label="Altura (cm)"
                                                    :value="item.avaliacaoAntropometrica.campos.alturaAcompanhamentoNutricional"
                                                />
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.avaliacaoAntropometrica.inconsistencias" />
                                    </rkm-area>
                                </rkm-col>

                                <rkm-col cols="6">
                                    <rkm-area
                                        title="Sinais vitais"
                                        type="fieldset"
                                    >
                                        <rkm-row>
                                            <rkm-col cols="6">
                                                <Item
                                                    label="Aferição de PA"
                                                    :value="item.sinaisVitais.campos.pressaoArterial"
                                                />
                                            </rkm-col>

                                            <rkm-col cols="6">
                                                <Item
                                                    label="Temperatura (ºC)"
                                                    :value="item.sinaisVitais.campos.temperatura"
                                                />
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.sinaisVitais.inconsistencias" />
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="6">
                                    <rkm-area
                                        title="Glicemia"
                                        type="fieldset"
                                    >
                                        <rkm-row>
                                            <rkm-col cols="6">
                                                <Item
                                                    label="Glicemia"
                                                    :value="item.glicemia.campos.glicemia"
                                                />
                                            </rkm-col>

                                            <rkm-col cols="6">
                                                <Item
                                                    label="Momento da coleta"
                                                    :value="item.glicemia.campos.tipoGlicemia"
                                                />
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.glicemia.inconsistencias" />
                                    </rkm-area>
                                </rkm-col>

                                <rkm-col cols="6">
                                    <rkm-area
                                        title="Desfecho"
                                        type="fieldset"
                                    >
                                        <rkm-row>
                                            <rkm-col cols="12">
                                                <Item
                                                    label="Desfecho"
                                                    :value="item.desfecho.campos.desfecho"
                                                />
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.desfecho.inconsistencias" />
                                    </rkm-area>
                                </rkm-col>
                            </rkm-row>
                        </div>
                    </template>
                </rkm-list>
                <Inconsistencia :inconsistencias="data.atendimentos.inconsistencias" />
            </rkm-area>
            
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),

        inconsistenciaVersao(){

            const texto = this.inconsistencia?.inconsistencia || ''
    
            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]    
        },
        atendimentosComInconsistencia(){
            return this.data.atendimentos.lista.map(item => ({
                ...item,
                _listItemColor: this.isInconsistencia(item) ? 'danger': ''
            }))
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {
            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        isInconsistencia(item){

            const blocos = [
                item.atendimento,
                item.motivosVisita,
                item.paciente,
                item.avaliacaoAntropometrica,
                item.glicemia
            ]

            const visitasDomiciliaresComInconsistencia =
                (item.visitasDomiciliares?.inconsistencias?.length || 0) > 0 ||
                item.visitasDomiciliares?.lista?.some(
                    problema => (problema?.inconsistencias?.length || 0) > 0
                )

            return blocos.some(b => (b?.inconsistencias?.length || 0) > 0)
                || visitasDomiciliaresComInconsistencia

        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },

        extrairVersao(texto){

            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
  

    },
    mixins: [repository, error]
}
</script>